import Back from "./back.png";
import banner from "./banner.png";
import BgArrow from "./bgArrow.png";
import HomePin from "./home-pin.png";
import Lock from "./lock.png";
import loginBg from "./loginBg.png";
import logo from "./logo.png";
import success from "./success.png";
import Union from "./union.png";
import UpgradeLG from "./upgrade-lg.png";
import UpgradeMD from "./upgrade-md.png";
import UpgradeSM from "./upgrade-sm.png";
import Upload from "./upload.png";

export const IMAGES = {
  logo,
  Lock,
  Union,
  loginBg,
  BgArrow,
  success,
  banner,
  Back,
  Upload,
  UpgradeLG,
  UpgradeMD,
  UpgradeSM,
  HomePin,
};

export const ASSETS_TYPE = "images";
